import { useState } from "react";
import { toast } from "sonner";
import { Linkedin, Facebook, Link2, MessageCircle } from "lucide-react";

const SHARE_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/share/articles`;

export default function ShareButtons({ slug, title, testid = "article-share" }) {
  const [copied, setCopied] = useState(false);
  const url = `${SHARE_BASE}/${slug}`;
  const enc = encodeURIComponent;
  const links = [
    { id: "linkedin", label: "LinkedIn", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`, cls: "hover:bg-[#0A66C2] hover:border-[#0A66C2]" },
    { id: "facebook", label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`, cls: "hover:bg-[#1877F2] hover:border-[#1877F2]" },
    { id: "whatsapp", label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${enc(`${title} — ${url}`)}`, cls: "hover:bg-[#25D366] hover:border-[#25D366]" },
  ];
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success("Lien copié"); setTimeout(() => setCopied(false), 2000); }
    catch { toast.error("Copie impossible"); }
  };
  return (
    <div data-testid={testid} className="flex flex-wrap items-center gap-2">
      <span className="text-xs uppercase tracking-widest text-[#94A3B8] mr-1">Partager</span>
      {links.map((l) => (
        <a key={l.id} href={l.href} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-${l.id}`} aria-label={`Partager sur ${l.label}`}
          className={`inline-flex items-center gap-1.5 border border-gray-300 text-[#1B2A4A] text-sm px-3 py-1.5 rounded-full hover:text-white transition-colors ${l.cls}`}>
          <l.icon className="w-4 h-4" /> <span className="hidden sm:inline">{l.label}</span>
        </a>
      ))}
      <button type="button" onClick={copy} data-testid={`${testid}-copy`} aria-label="Copier le lien"
        className="inline-flex items-center gap-1.5 border border-gray-300 text-[#1B2A4A] text-sm px-3 py-1.5 rounded-full hover:border-[#E0C173] hover:bg-[#E0C173] transition-colors">
        <Link2 className="w-4 h-4" /> <span className="hidden sm:inline">{copied ? "Copié" : "Copier le lien"}</span>
      </button>
    </div>
  );
}
